const VARS = {
  API_URL: "https://sudarshan.fonetricks.com",
  SOCKET_URL: "https://sudarshan.fonetricks.com"
}

export default VARS